module.exports = __webpack_public_path__ + "static/media/img-background4.67658177.jpg";